<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .container {
    height: 60%;
    width: 100%;
    display: flex;
    border-radius: 16px;
    flex-direction: column;
    justify-content: space-between;
    background-color: #e0f2fa;
    background-image: url("/assets/img/signup/background.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% auto;
    position: relative;
    .info-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: utils.in_rem(8px);
      padding: utils.in_rem(16px) utils.in_rem(100px);
      .free-trial {
        @include mixins.body3();
        color: colors.get(black_90);
      }
      .title {
        @include mixins.h1();
        color: colors.get(black_90);
      }
      .body-text {
        @include mixins.body2();
        color: colors.get(black_90);
        text-align: center;
      }
    }
    .purchase-container {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: utils.in_rem(8px);
      padding: utils.in_rem(16px) utils.in_rem(100px);
      .purchase-title {
        @include mixins.h2();
        color: colors.get(black_90);
      }
    }
  }
</style>

<script>
  import StatusTag from "@sourcewhale/shared/svelte-design-system/components/atoms/TagsAndChips/StatusTag.svelte";

  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import BookDemoButton from "../../pages/Explore/components/BookDemoButton.svelte";
  import CsInfo from "./CsInfo.svelte";

  const nDays = $userStore.plgTrialDaysRemaining || 0;
</script>

<div class="container">
  <div class="info-container">
    <StatusTag kind="neutral" contrast="low" size="medium">
      <span
        >{nDays === 1 ? "1 day" : `${nDays} days`} left of your free trial</span
      >
    </StatusTag>
    <div class="title">Keep using Notetaker & Inbox Agent</div>
    <div class="body-text">
      Get hours back every week with AI summaries of all your meetings with
      Notetaker - and AI generated email replies and automated follow-up
      sequences with Inbox Agent.
    </div>
  </div>
  <div class="purchase-container">
    <StatusTag
      kind="success"
      contrast="low"
      size="medium"
      leadingIcon="far fa-tag"
      style="border: 1px solid rgba(0, 130, 98, 0.10); display: flex; border-radius: 48px"
    >
      <span>15% off your first year</span>
    </StatusTag>
    {#if $userStore.plgDemoBooked}
      <Button kind="primary" size="large" class="disabled"
        >Meeting booked</Button
      >
    {:else}
      <BookDemoButton text="Get full access" />
    {/if}
  </div>
  <CsInfo />
</div>
